module.exports = __webpack_public_path__ + "img/jackpot.2cfcdd29.png";